import { Outlet, Link, createRootRoute } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Toaster } from "@/components/ui/sonner";
import { WhatsAppButton } from "@/components/layout/WhatsAppButton";


function NotFoundComponent() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="text-7xl font-serif text-gold">404</h1>
        <h2 className="mt-4 text-xl font-semibold text-foreground">Page not found</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          The page you're looking for doesn't exist.
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            Go home
          </Link>
        </div>
      </div>
    </div>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
});

function RootComponent() {
  return (
    <>
      <Helmet
        defaultTitle="Trendora Marts — Smart Shopping Starts Here"
        titleTemplate="%s — Trendora Marts"
      >
        <meta
          name="description"
          content="Trending gadgets, smart watches, kitchen essentials & kids toys with cash on delivery across Pakistan."
        />
        <meta property="og:title" content="Trendora Marts — Smart Shopping Starts Here" />
        <meta
          property="og:description"
          content="Trending gadgets, smart watches, kitchen essentials & kids toys with cash on delivery across Pakistan."
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Trendora Marts — Smart Shopping Starts Here" />
        <meta
          name="twitter:description"
          content="Trending gadgets, smart watches, kitchen essentials & kids toys with cash on delivery across Pakistan."
        />
      </Helmet>
      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster position="top-center" />
      </div>
    </>
  );
}
